import React from 'react';
import classnames from 'clsx';

import { testId } from 'ui-components/services/testid-service';

import { CustomsWidget } from './customs-widget';
import { ReadOnlyCustomsWidget } from './read-only-customs-widget';
import style from './style.module.less';
import ErrorBoundary from '../../error-boundary';

/**
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} props.fulfillmentPlanId
 * @param {boolean} [props.readOnly]
 * @param {React.ReactNode} [props.children] - Optional content rendered between header fields and declarations list
 * @returns {JSX.Element}
 */
const CustomsDeclarationsWidget = ({ className, fulfillmentPlanId, readOnly = false, children }) => (
  <ErrorBoundary errorMessageId='customsWidget'>
    <div key={fulfillmentPlanId} className={classnames(style['widget-wrapper'], className)} {...testId('customs-declarations-widget')}>
      {readOnly ? <ReadOnlyCustomsWidget /> : <CustomsWidget fulfillmentPlanId={fulfillmentPlanId}>{children}</CustomsWidget>}
    </div>
  </ErrorBoundary>
);

export default CustomsDeclarationsWidget;
